import React from 'react';
import { TouchableOpacity, StyleSheet, Platform, View } from 'react-native';
import { ChevronLeft, ChevronRight } from '../../icons';

interface CarouselNavArrowProps {
  direction: 'left' | 'right';
  onPress: () => void;
  disabled: boolean;
}

export const CarouselNavArrow: React.FC<CarouselNavArrowProps> = ({
  direction,
  onPress,
  disabled,
}) => (
  <TouchableOpacity
    style={[
      styles.arrow,
      direction === 'left' ? styles.left : styles.right,
      disabled && styles.disabled,
    ]}
    onPress={onPress}
    disabled={disabled}
    accessibilityRole="button"
    accessibilityLabel={direction === 'left' ? 'Previous attachment' : 'Next attachment'}
    testID={`carousel-nav-${direction}`}
  >
    <View style={styles.iconWrap}>
      {direction === 'left' ? (
        <ChevronLeft size={28} color={disabled ? 'rgba(255,255,255,0.2)' : '#fff'} />
      ) : (
        <ChevronRight size={28} color={disabled ? 'rgba(255,255,255,0.2)' : '#fff'} />
      )}
    </View>
  </TouchableOpacity>
);

const styles = StyleSheet.create({
  arrow: {
    position: 'absolute',
    zIndex: 10,
    ...Platform.select({
      web: {
        top: '50%',
        transform: 'translateY(-50%)',
      } as unknown as object,
      default: {
        top: '50%',
        transform: [{ translateY: -28 }],
      },
    }),
  },
  left: {
    left: 12,
  },
  right: {
    right: 12,
  },
  disabled: {
    opacity: 0.3,
  },
  iconWrap: {
    backgroundColor: 'rgba(0,0,0,0.55)',
    borderRadius: 28,
    padding: 8,
  },
});
